module.exports = __webpack_public_path__ + "img/banner03_info_culture.cbda201f.png";